var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h20v20H0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 13V7H5v6H3V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7h-2ZM5 16a2 2 0 0 1-2-2h14a2 2 0 0 1-2 2H5Z","fill":"#fff","key":1}),React.createElement("path",{"d":"M1 16a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1H1v-1Z","fill":"#fff","key":2})]);
}

Desktop.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Desktop;

Desktop.default = Desktop;
